<template>
  <div class="box">
    <v-layout
      d-block
      d-md-flex
      row
      ma-0
      align-center
      justify-space-between
      class="box-header"
    >
      <h3>{{ $t("audit-questions-box.unanswered_mandatory.title") }}</h3>
    </v-layout>

    <div class="box-content d-block">
      <!-- Private -->
      <v-row v-for="(quest, index) in questions.slice(0,7)" :key="index" class="px-3">
        <template v-if="quest">
          <v-layout
            ma-0
            xs9
            justify-start
            class="mb-6"
          >

            <router-link
              class="step link"
              :to="{
                name: 'edit-audit-unanswered',
                params: {
                answerid: answerid,
                sequenceid: sequenceid,
                firmid: firmid,
                questionid: quest.id
              }}"
              v-html="quest[`title_${$i18n.locale}`]"
            ></router-link>
            <!--
            <pre>{{quest}}</pre>
            <small v-html="quest[`title_${$i18n.locale}`] !== '' &&
                      quest[`title_${$i18n.locale}`] !== undefined &&
                      quest[`title_${$i18n.locale}`] !== 'undefined' &&
                      quest[`title_${$i18n.locale}`] !== null &&
                      quest[`title_${$i18n.locale}`] !== 'null' ? quest[`title_${$i18n.locale}`] :
                      quest['title_en'] !== '' &&
                      quest['title_en'] !== undefined &&
                      quest['title_en'] !== 'undefined' &&
                      quest['title_en'] !== null &&
                      quest['title_en'] !== 'null' ? quest['title_en'] :
                      quest['title_fr'] !== '' &&
                      quest['title_fr'] !== undefined &&
                      quest['title_fr'] !== 'undefined' &&
                      quest['title_fr'] !== null &&
                      quest['title_fr'] !== 'null' ? quest['title_fr'] : quest['title_nl']"></small> -->
          </v-layout>
          <v-layout
            ma-0
            xs3
            justify-end
            class="mb-6"
          >
            <small class="status secondary ml-5">{{ $t("basic-message.tags.waiting") }}</small>
          </v-layout>
        </template>
      </v-row>
    </div>
  </div>
</template>

<script>
import { showUSequence } from '@/js/survey/showUSequence';

export default {
  props: {
    questions: Array | Object,
    sequenceid: String,
    answerid: String,
    firmid: String
  }
}
</script>
